/* unplugin-vue-components disabled */import script from "./inputSend.vue?vue&type=script&setup=true&lang=js"
export * from "./inputSend.vue?vue&type=script&setup=true&lang=js"

import "./inputSend.vue?vue&type=style&index=0&id=77628bff&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77628bff"]])

export default __exports__